'use strict'

let self

export default self = {
  container : document.getElementById('scrollProgress'),

  init : () => {
    const max = self.getMaxValue()
    self.container.setAttribute("max", max)
    window.addEventListener('scroll', self.onScroll)
  },

  getMaxValue : () => document.body.clientHeight - window.innerHeight,

  onScroll : () => self.container.setAttribute("value", window.pageYOffset)

}
